import { PractitionerView } from '@dreryk/egabinet-personnel-frontend-api';

import {
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmExitConfig,
   ModalWidth,
} from '@dreryk/react-components';

import { practitionersTranslationKeys } from '../../../translations';

import { PractitionerUpdatePermissionsForm } from './PractitionerUpdatePermissionsForm';
import { PractitionerUpdatePermissionsModalConfirmButton } from './PractitionerUpdatePermissionsModal.buttons';
import { PractitionerUpdatePermissionsModalExitConfirmation } from './PractitionerUpdatePermissionsModal.exitConfirmation';

type PractitionerUpdatePermissionsModalProps = {
   readonly practitioner: PractitionerView;
   readonly onCancel: VoidFunction;
   readonly onUpdate: VoidFunction;
};

const renderEditModalContent = (
   props: PractitionerUpdatePermissionsModalProps,
   isDirty: boolean
): ModalConfirmExitConfig => ({
   content: (
      <PractitionerUpdatePermissionsModalExitConfirmation
         practitionerName={`${props.practitioner.firstName.asString()} ${props.practitioner.lastName.asString()}`}
         i18nKey={practitionersTranslationKeys.modal.leavingFromEditingContent}
      />
   ),
   enabled: isDirty,
   modalWidth: ModalWidth.NORMAL,
   title: practitionersTranslationKeys.modal.leavingFromEditingTitle,
   confirmationButtonLabel: practitionersTranslationKeys.modal.leave,
});

export const PractitionerUpdatePermissionsModal = (props: PractitionerUpdatePermissionsModalProps): JSX.Element => {
   return (
      <Modal
         title={practitionersTranslationKeys.modal.title}
         onCloseRequest={props.onCancel}
         animateVisibility
         width={ModalWidth.WIDE}
         testId={'patientRemove'}
         shouldCloseOnEsc={false}
         shouldCloseOnOverlayClick={false}
         visible
      >
         <PractitionerUpdatePermissionsForm practitioner={props.practitioner}>
            {({ formState, handleSubmit }) => {
               return (
                  <>
                     <PractitionerUpdatePermissionsModalConfirmButton
                        practitionerId={props.practitioner.id}
                        onUpdate={props.onUpdate}
                        handleSubmit={handleSubmit}
                     />
                     <ModalCancelButton
                        onClick={props.onCancel}
                        shouldConfirmExit={renderEditModalContent(props, formState.isDirty)}
                     />
                     <ModalCloseButton
                        onClick={props.onCancel}
                        shouldConfirmExit={renderEditModalContent(props, formState.isDirty)}
                     />
                  </>
               );
            }}
         </PractitionerUpdatePermissionsForm>
      </Modal>
   );
};
